import React from 'react';
import { Text } from '@react-pdf/renderer';
import { pdfStyles } from '../styles/pdf-styles';

interface PDFSectionHeaderProps {
  title: string;
  variant?: 'primary' | 'secondary' | 'alignement' | 'epaysage';
  style?: any;
}

/**
 * Reusable PDF section header component
 */
export const PDFSectionHeader: React.FC<PDFSectionHeaderProps> = ({
  title,
  variant = 'secondary',
  style,
}) => {
  const headerStyle = variant === 'primary'
    ? pdfStyles.sectionHeaderPrimary
    : variant === 'alignement'
      ? pdfStyles.sectionHeaderAlignement
      : variant === 'epaysage'
        ? pdfStyles.sectionHeaderEpaysage
        : pdfStyles.sectionHeader;

  return (
    <Text style={[headerStyle, style]}>
      {title}
    </Text>
  );
};
